module.exports = __webpack_public_path__ + "img/add.ae789050.svg";